<template>
    <div>
        <product-view-component :type="0" :max-prize="500"></product-view-component>
    </div>
</template>
<script>
import productPreviewComponent from "@/components/ProductPreviewComponent.vue"

export default {
    components: {
        "product-view-component": productPreviewComponent
    }
}
</script>
<style scoped lang="less">

</style>